<template>
  <section>
    <header-doc slot="header"></header-doc>
    <menu-examples slot="sidebar"></menu-examples>
    <div class="content">
      <buttons></buttons>
      <grid></grid>
      <forms></forms>
      <icons></icons>
    </div>
  </section>
  </article>
</template>

<style lang="less">

  @import '../assets/styles/main';
  @import '../assets/styles/doc';

</style>

<script>
  import HeaderDoc from '../components/HeaderDoc'
  import RoundButton from '../components/RoundButton'
  import SimpleButton from '../components/SimpleButton'
  import MenuExamples from '../components/MenuExamples'
  import Buttons from '../components/Buttons'
  import Grid from '../components/Grid'
  import Forms from '../components/Forms'
  import Icons from '../components/Icons'

  export default {
    components: {
      HeaderDoc,
      RoundButton,
      MenuExamples,
      SimpleButton,
      Buttons,
      Grid,
      Forms,
      Icons
    }
  }
</script>




// WEBPACK FOOTER //
// Guide.vue?4800e8e8